var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0_1639_425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1639_425",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1639_425",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1639_425",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKzSURBVHgB7ZlNaBNBFMf/Gzy6waO1Hjy0pj1YsNiIioWWCqJQSQW9WAr2JEbUi6goVBQpniKm9NRCrB5UtPbgB1haqKiYlgr1kDT14CXqsSS92nXeJllmN7uSHbPZFeYHy37MTPb933vzdsgAEn9R+JvdHYeGoG0m2OU2BJPvUEIjuZUPqcqDEN+qaJsjCK7xxK6ygw1MAjTqEHxMDg7hP0cK8BspwG/qImD09g2EwypEiZ04hr7eboiwBQLEzw3DakChWGTHhvHs4eOnKBSK+vXUZBIvZl5jmh1E844mzL19jt6jJ5H/8RPRfZ36eXZuAW4REkAvq0DG2D23spP1i3Z1lsdsR70QEmB4srkJY4nTSC8t6ymQYl7P5+1FRLv2GmJVdWtV+9CZUxhgkbx7776rSLgW0N7Wilj/cXZuQVukFcnxSaQePdHTaGoiqUchk/2G2fkFpBeXjXHWFLLm/PTMG/13ilwaeiKA1huZ1Rx74St2XuMMKBlIadIeaakypK+n24hA2CYCNIf+loJOuBJABrx8lqq5/+BwXI8CeZ+fKzTZH4xPoLjhztt2mJfTew5oEGB15aNRUZyg1KOUcyLLopnJrqEWcl8/GXYLTeKxxKhuEA+VygqfF7/g2s07pnZVVU1R4DnScxjv5t/XLIBHSMD5S1cd22gyUzWxQtFJL9mP2c8qlChCAsjblA5OFcPOk7H+krA0i46VfP6XnkIiCAkgqF5XymKt2KXWvyIs4PqVi7hgWVLwDJ6NV03qAYf0qhDpOAi31KUKNRq+CsnltN9IAX4jBfiNVcA6go7C/h/lCJlvtMuKpUOgULCu/dZuoVHQh9Hrj6OcxH4jBfiNFOA3UoDfSAFO6HvONtf1xjMB5T3nEpa93XrimQCN389VvFvleibAWNk2egUpaTB/AKAQ9gcWlR8KAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerStart);
export default __webpack_public_path__ + "static/media/markerStart.1267b02b3a660f3e5cba0e69b6a0e97a.svg";
export { ForwardRef as ReactComponent };